module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNiAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNi42MDkxOUgxNlYxMEgwVjYuNjA5MTlaTTAgMEgxNlYzLjM5MDgxSDBWMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/equal.svg
// module id = 13879
// module chunks = 0